export const QUERY_KEY_LESSON = 'lesson';
export const QUERY_KEY_LESSONS = 'lessons';
export const QUERY_KEY_SEARCH = 'search';
export const QUERY_KEY_SEARCH_IN_LESSON = 'searchInLesson';
